import { isColorDark } from '../utils/isColorDark'

const ProgressBar = ({ progress = 0, accentColor }: { progress?: number; accentColor: string }) => {
  const isAccentColorDark = isColorDark(accentColor)

  // If progress is more than 100% we set it to 100% to avoid overflowing the progress bar
  const progressValue = progress > 100 ? 100 : progress

  return (
    <div className={`shrink-0 h-[9px] w-full rounded-[9px] overflow-hidden mt-4 bg-zinc-300/45 dark:bg-zinc-300/30`}>
      <div
        style={{ width: progress < 5 ? '18px' : `${progressValue}%`, background: accentColor }}
        className={`h-full bg-black dark:bg-[#BFBFBF] rounded-[9px] ${isAccentColorDark ? 'border-zinc-800 border' : ''}`}
      />
    </div>
  )
}

export default ProgressBar
